import { Button, Form, Input, Modal, Row, Select } from 'antd'
import './AddDefectItemModal.style.less'
import { useMutation } from 'react-query'
import {
  saveDefectItem,
  updateDefectItem,
} from '../../../DataManagement.transform'
import { queryClient } from '@/config/react-query'
import { isEmptyValue } from '@/utils/common'
import { useParams } from 'react-router-dom'

interface Props {
  visible: boolean
  onClose: () => void
  data: any
}

function AddDefectItemModal(props: Props) {
  const param = useParams()

  const mutation = useMutation(async (data: any) => {
    await saveDefectItem({ ...data, defect_group_id: param?.id })
  })

  const updateMutation = useMutation(async (data: any) => {
    await updateDefectItem(data.id, {
      ...data.data,
      defect_group_id: param?.id,
    })
  })

  const onSaveSupplier = async (data) => {
    if (!isEmptyValue(props.data)) {
      await updateMutation.mutateAsync({ id: props.data.id, data })
    } else {
      await mutation.mutateAsync(data)
    }
    await queryClient.refetchQueries(['defect-item', param?.id])
    props.onClose()
  }

  return (
    <Modal
      className="modal-add-defect-container"
      open={props.visible}
      width={660}
      footer={false}
      maskClosable={false}
      onCancel={props.onClose}
    >
      <div>
        <p className="title">
          {!isEmptyValue(props.data) ? 'Edit' : 'New'} Defect Item
        </p>
        <Form labelCol={{ span: 7 }} onFinish={onSaveSupplier}>
          <Form.Item
            name="name"
            label="Defect Name"
            initialValue={props.data?.name}
            rules={[{ required: true, message: 'This field is required' }]}
          >
            <Input size="large" placeholder="Text" />
          </Form.Item>
          <Form.Item initialValue={props.data?.code} name="code" label="Code">
            <Input size="large" placeholder="Text" />
          </Form.Item>
          <Form.Item
            initialValue={props.data?.head_rank}
            name="head_rank"
            label="Head Rank"
          >
            <Input size="large" placeholder="Text" />
          </Form.Item>
          <Form.Item
            initialValue={props.data?.details}
            name="details"
            label="Details"
          >
            <Input size="large" placeholder="Text" />
          </Form.Item>
          <Form.Item
            initialValue={props.data?.classification}
            name="classification"
            label="Classification"
          >
            <Select placeholder="Select" size="large">
              <Select.Option value="critical">Critical</Select.Option>
              <Select.Option value="major">Major</Select.Option>
              <Select.Option value="minor">Minor</Select.Option>
            </Select>
          </Form.Item>
          <Row className="button-container">
            <Button onClick={props.onClose} size="large">
              Cancel
            </Button>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              loading={mutation.isLoading || updateMutation.isLoading}
            >
              {!isEmptyValue(props.data) ? 'Save' : 'Create'}
            </Button>
          </Row>
        </Form>
      </div>
    </Modal>
  )
}

export default AddDefectItemModal
